import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { SessionService, AuthService, ApiService } from '../../../services/index';

@Component({
  selector: 'sn-timout-dialog',
  templateUrl: './timout-dialog.component.html',
  styleUrls: ['./timout-dialog.component.css']
})
export class TimoutDialogComponent implements OnInit {
  constructor(
    protected sessionService: SessionService,
    protected authService: AuthService,
    protected apiService: ApiService,
    public activeModal: NgbActiveModal,
  ) { }

  public time_remaining: string = "10 Minutes";
  public yes: string = "YES";
  public no: string = "NO";

  ngOnInit() {
    this.sessionService.onIdleTimerStart().subscribe(count => {
      var idle_values = this.sessionService.getUserIdleConfigValues();
    });
  }

  onSubmit(response) {
    this.activeModal.close({ response: response });
    this.authService.extendAuthSession().subscribe(
      data => { console.log("Session Extended") },
      err => { console.log(err) }
    )
  }

  onCancel(response) {
    this.activeModal.dismiss(response);
  }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/dialogs/timout-dialog/timout-dialog.component.ts